e.Me.all_media_items = {
	filters : {},

	init : function(){

		this._init_media_filter();
	},

	/**
	 * Adds the everyones media items dropdown option
	 * to the media uploader ui
	 *
	 *
	 * @private
	 */
	_init_media_filter : function(){
		if( typeof( wp ) == 'undefined' ){
			return;
		}
		if( typeof( wp.media ) == 'undefined' ){
			return;
		}
		wp.media.view.AttachmentFilters.Uploaded.prototype.createFilters = function(){
			l10n = wp.media.view.l10n = typeof _wpMediaViewsL10n === 'undefined' ? {} : _wpMediaViewsL10n;
			var filters = {};

			_.each( wp.media.view.settings.mimeTypes || {}, function( text, key ){
				filters[key] = {
					text : text,
					props : {
						status : null,
						type : key,
						uploadedTo : null,
						orderby : 'date',
						order : 'DESC'
					}
				};
			} );

			filters.all = {
				text : l10n.allMediaItems,
				props : {
					status : null,
					type : null,
					uploadedTo : null,
					orderby : 'date',
					order : 'DESC'
				},
				priority : 10
			};

			if( wp.media.view.settings.post.id ){
				filters.uploaded = {
					text : l10n.uploadedToThisPost,
					props : {
						status : null,
						type : null,
						uploadedTo : wp.media.view.settings.post.id,
						orderby : 'menuOrder',
						order : 'ASC'
					},
					priority : 20
				};
			}

			filters.unattached = {
				text : l10n.unattached,
				props : {
					status : null,
					uploadedTo : 0,
					type : null,
					orderby : 'menuOrder',
					order : 'ASC'
				},
				priority : 50
			};

			if( wp.media.view.settings.mediaTrash && this.controller.isModeActive( 'grid' ) ){

				filters.trash = {
					text : l10n.trash,
					props : {
						uploadedTo : null,
						status : 'trash',
						type : null,
						orderby : 'date',
						order : 'DESC'
					},
					priority : 50
				};
			}

			filters.everyone = {
				text : config.i18n.show_everyones_items,
				props : {
					status : null,
					type : null,
					uploadedTo : null,
					orderby : 'date',
					order : 'DESC',
					removeMyFilter : 1
				},
				priority : 60
			};


			this.filters = filters;
		}
	}

};